export const FETCH_ACTIVE_REGISTER = 'FETCH_ACTIVE_REGISTER';
export const OPEN_CASH_REGISTER = 'OPEN_CASH_REGISTER';
export const CLOSE_CASH_REGISTER = 'CLOSE_CASH_REGISTER';
export const ADD_PAYOUT = 'ADD_PAYOUT';
export const FETCH_CASH_REGISTER_HISTORY = 'FETCH_CASH_REGISTER_HISTORY';
export const OPEN_CASH_REGISTER_DRAWER = 'OPEN_CASH_REGISTER_DRAWER';
